import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationStateService {
  private isDesktopCollapsedSubject = new BehaviorSubject<boolean>(false);
  private isMobileMenuOpenSubject = new BehaviorSubject<boolean>(false);
  
  // Desktop collapsed state
  public isDesktopCollapsed$: Observable<boolean> = this.isDesktopCollapsedSubject.asObservable();
  
  // Mobile menu state
  public isMobileMenuOpen$: Observable<boolean> = this.isMobileMenuOpenSubject.asObservable();
  
  constructor() {
    this.loadDesktopCollapsedState();
  }
  
  // Desktop collapsed state methods
  get isDesktopCollapsed(): boolean {
    return this.isDesktopCollapsedSubject.value;
  }
  
  setDesktopCollapsed(collapsed: boolean): void {
    this.isDesktopCollapsedSubject.next(collapsed);
    this.saveDesktopCollapsedState(collapsed);
  }
  
  toggleDesktopCollapsed(): void {
    const newState = !this.isDesktopCollapsed;
    this.setDesktopCollapsed(newState);
  }
  
  // Mobile menu state methods
  get isMobileMenuOpen(): boolean {
    return this.isMobileMenuOpenSubject.value;
  }
  
  setMobileMenuOpen(open: boolean): void {
    this.isMobileMenuOpenSubject.next(open);
  }
  
  toggleMobileMenu(): void {
    const newState = !this.isMobileMenuOpen;
    this.setMobileMenuOpen(newState);
  }
  
  // Persistence methods
  private saveDesktopCollapsedState(collapsed: boolean): void {
    localStorage.setItem('desktop-nav-collapsed', collapsed.toString());
  }
  
  private loadDesktopCollapsedState(): void {
    const saved = localStorage.getItem('desktop-nav-collapsed');
    if (saved !== null) {
      const collapsed = saved === 'true';
      this.isDesktopCollapsedSubject.next(collapsed);
    }
  }
  
  // Reset methods
  resetDesktopCollapsed(): void {
    this.setDesktopCollapsed(false);
  }
  
  resetMobileMenu(): void {
    this.setMobileMenuOpen(false);
  }
  
  // Utility methods
  isMobileView(): boolean {
    return window.innerWidth < 992;
  }
  
  // Get current state synchronously
  getCurrentState() {
    return {
      isDesktopCollapsed: this.isDesktopCollapsed,
      isMobileMenuOpen: this.isMobileMenuOpen,
      isMobile: this.isMobileView()
    };
  }
}
